// frontend/src/services/api/index.js
import axios from 'axios';
import { getToken } from '../auth/tokenService'; 

// Create an Axios instance with default config
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? 'https://api.facewithtongue.com/api'
    : 'http://localhost:8000/api',
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add a request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Export the API client
export default api;